import "@mind/ui/tokens.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import "./i18n/index.js";
import { router } from "./app/router.js";
import { bootstrapFragmentSecret, startFragmentExchange } from "./auth/index.js";

bootstrapFragmentSecret();
void startFragmentExchange();

const rootElement = document.getElementById("root");
if (rootElement === null) throw new Error("Missing #root application mount");
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, retry: false },
    mutations: { retry: false },
  },
});

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
